// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3eU8X","inner":"Form_inner__3vQX0","range":"Form_range__2ixwz","name":"Form_name__XgDbt","actions":"Form_actions__SxtN3"};